// 必要なコンポーネントやライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用のフレームコンポーネント
import { Container, Box, Typography, Button } from '@mui/material'; // Material-UIのコンテナ、ボックス、タイポグラフィ、ボタンコンポーネント

/** 
 * 仮パスワード発行テンプレートコンポーネント
 * ユーザーが仮パスワードをリクエストするためのUIを提供
 */
const UserMailTemplate = () => {

    return (
        // ユーザー専用フレームで全体をラップ
        <UserFrame title=''> {/* タイトルは空の状態 */}
            {/* コンテンツの最大幅を`sm`（スモールサイズ）に設定 */}
            <Container maxWidth='sm'>
                {/* 仮パスワード発行フォームを囲むボックス */}
                <Box sx={{ height: '600px', width: '100%', padding: '20px' }}>
                    {/* メールアドレス入力ラベル */}
                    <Typography>
                        メールアドレス入力
                    </Typography>
                    {/* メールアドレス入力フィールド */}
                    <input type="text" size={50} />

                    {/* 注意メッセージ */}
                    <Typography sx={{ paddingTop: '10px', color: 'red' }}>
                        管理者へ問い合わせを行って下さい
                    </Typography>

                    {/* 仮パスワード発行ボタン */}
                    <Button variant="outlined">仮パスワード発行</Button>
                </Box>
            </Container>
        </UserFrame>
    )
}

// コンポーネントをエクスポート
export default UserMailTemplate;
